jQuery(document).ready(($) => {
  const headerTag = $('header').height();
  //replace h2 html with span + text
  //Smooth Scroll Start
  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
        location.hostname == this.hostname
      ) {
        let target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

        if (target.length) {
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - headerTag,
          }, 500);
        }
      }
    });

  $('.read__more').on('click', function (e) {
    e.preventDefault();
    $(this).hide();
    $(this).closest('.highlight__text').removeClass('highlight__text--overflow');
  })
});


